import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // INFO - The prompt optimizer is hidden by default.
  isPromptOptimizerEnabled: import.meta.env.REACT_APP_ENV !== 'production',
};

const promptOptimizerSlice = createSlice({
  name: 'promptOptimizer',
  initialState,
  reducers: {
    setPromptOptimizerEnabled: (state, action) => {
      state.isPromptOptimizerEnabled = action.payload;
    },
  },
});

export const { setPromptOptimizerEnabled } = promptOptimizerSlice.actions;
export default promptOptimizerSlice.reducer;